import { Component, type ReactNode } from 'react';
import { isChunkLoadError } from '../lib/lazyWithRetry';

interface Props {
  children: ReactNode;
}

interface State {
  error: unknown;
  failed: boolean;
}

/**
 * Fejlgrænse om en fanes indhold. Fanger især en side-chunk, der ikke kan hentes
 * efter et nyt deploy, så fanen ikke bliver blank, og resten af appen virker.
 */
export class TabErrorBoundary extends Component<Props, State> {
  state: State = { error: null, failed: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Fanen kunne ikke vises', error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const chunk = isChunkLoadError(this.state.error);
    return (
      <div className="error-note tab-error" role="alert">
        <span>
          {chunk
            ? 'Der er kommet en ny version. Genindlæs siden for at åbne fanen.'
            : 'Fanen kunne ikke vises.'}
        </span>{' '}
        <button type="button" className="btn btn-secondary" onClick={() => window.location.reload()}>
          Genindlæs
        </button>
      </div>
    );
  }
}
